<script>
import { eventBus } from "../main";
import navigation from "../mixins/navigation.js";
import draggable from 'vuedraggable'

function shuffle(a) {
  var j, x, i;
  for (i = a.length - 1; i > 0; i--) {
    j = Math.floor(Math.random() * (i + 1));
    x = a[i];
    a[i] = a[j];
    a[j] = x;
  }
}
export default {
  mixins: [navigation],
  name: 'app',
  components: {
    draggable
  },
  data() {
    return {
      last: "P_14",
      next: "P_16",
      topic: "",
      dialog: false,
      resultado: 0,
      response: 'none',
      sent: false,
      show: false,
      reactivos: [{
          pregunta: 'No hay flexibilidad por retrasos en el pago',
          correcta: 'Tanda',
          respuesta: [],
          respuestaUnica: '',
          resultado: 0
        },
        {
          pregunta: 'Podrían no prestarme todo lo que necesito.',
          correcta: 'Pedirle prestado a tu hermano',
          respuesta: [],
          respuestaUnica: '',
          resultado: 0
        },
        {
          pregunta: 'Permite obtener un bien sin desembolsar una cantidad grande de dinero.',
          correcta: 'Crédito Hipotecario',
          respuesta: [],
          respuestaUnica: '',
          resultado: 0
        }
      ],
      respuestas: [
        "Tanda",
        "Pedirle prestado a tu hermano",
        "Crédito Hipotecario"
      ],
    }
  },
  methods: {
    grade: function(reactivos) {
      var points = 0;
      this.reactivos.forEach(function(reactivo) {
        if (reactivo.correcta === reactivo.respuesta[0]) {
          reactivo.resultado = 1;
          points++;
        }
      });
      this.resultado = points / this.reactivos.length;
    },
    sendResult() {
      this.grade();
      this.sent = true;
      eventBus.$emit('send_result', this.resultado);
      eventBus.$emit('suspend_data', this.reactivos);
    }
  },
  computed: {
    responseIsNone() {
      return {
        'btn-primary': this.response != 'none',
        'btn-secondary': this.response == 'none'
      }
    }
  },
  beforeMount: function() {
    shuffle(this.respuestas);
  },
  beforeUpdate: function() {
    var respuestas = this.respuestas;
    this.reactivos.forEach(function(reactivo) {
      if (reactivo.respuesta.length == 2) {
        if (reactivo.respuesta[0] == reactivo.respuestaUnica) {
          respuestas.push(reactivo.respuesta.shift());
        } else {
          respuestas.push(reactivo.respuesta.pop());
        }
      }
      reactivo.respuestaUnica = reactivo.respuesta[0];
    });
  },
  created() {
    if ('suspend_data'in this.$parent) {
      if (this.$parent.currentPage in this.$parent.suspend_data) {
        this.reactivos = this.$parent.suspend_data[this.$parent.currentPage];
        this.sendResult();
      }
    }
  },
  computed: {
    responseIsNone() {
      return {
        'btn-primary': this.response != 'none',
        'btn-secondary': this.response == 'none'
      }
    }
  }
}
</script>

<template lang="pug">
v-app(style='background: #FFFFFF !important;')
  v-container(fluid, grid-list-xl)
    v-content
      v-layout(row justify-center)
        v-flex(xs12 sm12 md10 lg9 text-xs-center)
          .review(v-if='sent', color='primary', @click.prevent='')
          v-card(flat)
            breadcrumb(:back='last') {{topic}}
            v-card-text.label16tt.withDivider
              span(style='color:#F7893B ') JUEGO - RONDA 3
            v-card-text.titulo24Reg.text-center
              | A continuación hay tres tendrás tres tipos de financiamiento y tres características. Debes arrastrar cada característica al tipo de financiamiento correspondiente. 
            v-card-text.parrafoDestacadoB.text-center.mb-2
              | Arrastra para ordenar
            v-container(grid-list-md text-center)
              draggable( :emptyInsertThreshold="20" v-model='respuestas' group='people' tag='div', style="display:flex; flex-wrap: wrap; justify-content: space-between;")
                div(v-for='(respuesta, index) in respuestas' :key='respuesta')
                  v-card(flat min-height=70)
                    v-card.selectorBox(flat width=300)
                      v-card-text.reactivo.px-0.text-uppercase {{ respuesta }}

              v-container(grid-list-md text-center)
                v-layout(wrap align-center justify-center)
                  v-flex.xs12.md4(v-for="(reactivo, index) in reactivos" :key='reactivo.pregunta')
                    v-card(flat dark color="error" min-height=80)
                      v-card-text {{reactivo.pregunta}}
                    v-card(flat)
                      div.grey--text(style="position: relative; top:20px; height: 0px") Arrastra Aquí
                      draggable.selectorBox.ma-0.pa-0(:emptyInsertThreshold="20" v-model='reactivo.respuesta' group='people' tag='div')
                        v-flex.ma-0.pa-0(v-for='(item, jndex) in reactivo.respuesta' :key='item')
                          v-card.selectorBox(flat)
                            v-card-text.reactivo.px-0.text-uppercase 
                              v-icon(size='15px' v-if='sent && (reactivo.resultado==0)' color='red ') fas fa-times
                              v-icon(size='15px' v-if='sent && (reactivo.resultado==1)' color='green ') fas fa-check                
                              span.mx-1 {{ item }}  

            v-layout(row, justify-center)
              v-flex
                div(v-if='sent==false ')
                  v-btn.btn(color='secondary ', v-bind:class='responseIsNone ', :disabled='respuestas.length!=0 ', @click='sendResult() ')
                    | Enviar
                div(v-if='sent ')
                  v-btn.btn(color='accent ', style='z-index:2', @click.prevent='dialog=true ')
                    | Retroalimentación
                  v-dialog(v-model='dialog ', scrollable, persistent, max-width='930px ')
                    v-card.pa-0.ma-0
                      v-card-text.pa-0.ma-0(style='height: 500px;')
                        v-layout(row, justify-center)
                          v-flex(text-xs-center)
                            div(v-if='sent && (resultado==1) ')
                              v-layout(row, justify-center)
                                v-flex(text-xs-center)
                                  img.dialog_img(src='@/assets/ManoOk.png')
                              v-spacer.my-1.py-4
                              v-card-text.headline
                                | ¡Muy bien!
                            div(v-if='sent && (resultado!=1) ')
                              v-layout(row, justify-center)
                                v-flex(text-xs-center)
                                  img.dialog_img(src='@/assets/ManoStop.png')
                              v-spacer.my-1.py-4
                              v-card-text.headline
                                | ¿Estás seguro?
                            v-card.questionCard.ma-0.pa-0(flat)
                              v-card-text.dialog_text
                                p.text-sm-left.px-5.my-0(v-if='sent && (resultado==1) ')
                                  | Tienes muy claro que con un crédito hipotecario puedes comprar una casa y pagarla poco a poco. 
                                p.text-sm-left.px-5.my-0
                                  | En la tanda puedes tener dinero inmediato, pero no hay contrato o algún otro tipo de respaldo legal. 
                                p.text-sm-left.px-5.my-0
                                  | El préstamo familiar podría no garantizar el monto que necesitas. 
                            v-btn.btn.dialog_btn(style='z-index:2 ', color='accent ', @click.prevent="nextPage(next)")
                              | Siguiente
          l-progress(:value='this.$parent.currentPage')
</template>


